<section class="attachments">
  <div class="attachments__choose">
    <h2 class="section-header">Attachmets: add optional files to be included in fax</h2>
    <label class="btn_primary btn_lg attachments__choose-button">
      Choose file
      <input
        (change)="onUserSelectedFile($event)"
        [disabled]="isLimitReached()"
        type="file"
        [accept]="acceptedFileFormats"
        multiple
        #files
      />
    </label>
    <span class="attachments__choose-counter">
      {{ getFilesNumberText() }}
    </span>
  </div>

  <div class="attachments__files">
    <div class="attachments__selected-files">
      <h2 class="section-header">Selected files:</h2>
      <ul class="selected-files__list">
        <li *ngFor="let file of selectedFiles" class="selected-files__list-item">
          <img (click)="deleteFile(file)" src="assets/img/icons/delete-orange.svg" alt="delete file" />
          {{ file?.name }}
        </li>
      </ul>
    </div>
    <div class="attachments__accepted-formats">
      <h2 class="section-header">Accepted File Formats:</h2>
      <ul class="accepted-formats__list">
        <li class="accepted-formats__list-item">Image Files (PNG, JPEG)</li>
        <li class="accepted-formats__list-item">Adobe Acrobat Files (PDF)</li>
        <li class="accepted-formats__list-item">Microsoft Office Files (DOC, DOCX)</li>
        <li class="accepted-formats__list-item">Text Files (TXT)</li>
      </ul>

      <p class="accepted-formats__list-item">Files can't be more than 500 MB</p>
      <p class="accepted-formats__list-item">Maximum files amount - 10</p>
    </div>
  </div>

  <div class="send-page__actions">
    <button (click)="navigateToPreviousPage()" class="btn_secondary btn_md attachments__button_edit">
      <img src="assets/img/icons/arrow_back.svg" alt="return back" />
      Edit
    </button>
    <button (click)="submitAttachments()" class="btn_primary btn_md attachments__button_next">Next</button>
  </div>
</section>
